module.exports = "/_next/static/images/12680c9d5f8109c2c59f18091753e899-Nubank_HickDuarte_54700_md.jpg";